import * as types from "./negara.actionTypes";
import { createAsyncAction } from "typesafe-actions";
import { ErrorResponse } from "../../interfaces/ErrorResponse";
import { NegaraListResponse } from "./types";

export const getNegaraAsync = createAsyncAction(
  types.GET_NEGARA_REQUEST,
  types.GET_NEGARA_SUCCESS,
  types.GET_NEGARA_FAILURE
)<undefined, NegaraListResponse, ErrorResponse>();